/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Parametric_TitleInputs */

const en_cad_features_parametric_title = /** @type {(inputs: Cad_Features_Parametric_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constraints that re-solve on edit`)
};

/**
* | output |
* | --- |
* | "Constraints that re-solve on edit" |
*
* @param {Cad_Features_Parametric_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_parametric_title = /** @type {((inputs?: Cad_Features_Parametric_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Parametric_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_parametric_title(inputs)
});
export { cad_features_parametric_title as "cad.features.parametric_title" }